// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';
import 'jquery-match-height';
import Flipsnap from 'flipsnap';
import enquire from 'enquire.js';
import objectFitImages from 'object-fit-images';
import 'lazysizes';

import SiteHeader from '../_modules/organisms/site-header/site-header';
import SiteFooter from '../_modules/organisms/site-footer/site-footer';
import FriendForm from '../_modules/molecules/friend-form/friend-form';
import ShareThoughtsForm from '../_modules/molecules/share-thoughts-form/share-thoughts-form';

$(() => {

    $('.match-height').matchHeight();
    $('.match-height--title').matchHeight();
    $('.match-height--content').matchHeight();

    const $newsWrapper = $('.news-wrapper'),
        $newsViewport = $('.news-viewport');

    enquire.register("screen and (max-width:960px) and (min-width:768px)",{
		match : function(){
			if($('.news-wrapper').length) {
                Flipsnap('.news-wrapper',{
                    disableTouch: false,
                    distance: 257
                }).refresh();
            }
		},
		unmatch: function(){
			$newsWrapper.removeAttr('style');
			var newsviewport = $newsViewport.html();
			$newsWrapper.remove();
			$newsViewport.html(newsviewport);
		}
    });

    const getUrlParameter = param => {
        let sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === param) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    if($('.scroll-to-load').length){
        $('html, body').animate({
            scrollTop: $('.scroll-to-load').offset().top
        },2000);
    }

    if ($('.header').length) {
		let header = new SiteHeader();
    }

    if($('.site-footer').length) {
        let footer = new SiteFooter();
    }

    if($('.be-our-friend-form').length || $('.share-thoughts-form').length ) {
        let friendForm = new FriendForm();
    }

    if($('.search-container').length) {
        let paramValue = getUrlParameter('q').split('+').join(' ');
        $('.search-term').text(`Search Result for "${paramValue}"`);
    }


    objectFitImages();

    // Activate ShareThoughtsForm
    new ShareThoughtsForm();

});
